import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState, useEffect } from 'react';
import Page from '../../../../page';
import Visualizations from './Sidebar/Visualizations';
import Properties from './Sidebar/Properties';
import { selectWidgets } from './context/selectors/widgetsSelector';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { DesignImdbProvider } from '../../Preview/DashboardPreview/designImdbContext';
import { DashboardProvider, useDashboardState, useDashboardDispatch, reset } from './context/dashboardContext';
import Utils from '../../../../utils';
import ToolbarCenterButtons from './ToolbarCenterButtons';
import BlockPrompt from '../../../../form/BlockPrompt';
import WidgetPreview from './WidgetPreview';
/**
 * @param {import('./types').DashboardEditorProps} props
 */

var DashboardEditor = function DashboardEditor(props) {
  var dashboardState = useDashboardState();
  var dashboardDispatch = useDashboardDispatch();

  var _useState = useState('visualizations'),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedWidgetId = _useState4[0],
      setSelectedWidgetId = _useState4[1];

  useEffect(function () {
    var asyncEffect =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return reset(dashboardDispatch, props.workspace, props.path);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function asyncEffect() {
        return _ref.apply(this, arguments);
      };
    }();

    asyncEffect();
  }, [props.workspace, props.path]);
  var widgets = selectWidgets(dashboardState); // select first widget by default if no selectedItemId is provided as prop

  useEffect(function () {
    if (widgets.length === 0) {
      setSelectedWidgetId(null);
    } else if (selectedWidgetId === null || !widgets.find(function (widget) {
      return widget.id === selectedWidgetId;
    })) {
      if (selectedWidgetId === null && props.selectedItemId && widgets.find(function (widget) {
        return widget.id == props.selectedItemId;
      })) setSelectedWidgetId(props.selectedItemId);else setSelectedWidgetId(widgets[0].id);
    }
  }, [dashboardState.content]);
  return React.createElement("div", null, React.createElement(Page.ToolBar, {
    icon: {
      type: 'close',
      onClick: function onClick() {
        return props.onClose();
      }
    },
    leftChildren: Utils.path.getFileCaption(props.path),
    centerChildren: dashboardState.content && React.createElement(ToolbarCenterButtons, {
      workspace: props.workspace,
      path: props.path
    }),
    color: "navbar"
  }), !dashboardState.error && dashboardState.content === undefined ? React.createElement(Box, {
    top: "calc(50% - 25px)",
    left: "calc(50% - 25px)",
    position: "absolute"
  }, React.createElement(CircularProgress, null)) : React.createElement(Page.Common, {
    style: {
      backgroundColor: 'white'
    },
    sidebar: !dashboardState.error && {
      variant: 'properties',
      options: [{
        label: 'Visualizations',
        icon: 'page',
        value: 'visualizations'
      }, {
        label: 'Properties',
        icon: 'style',
        value: 'properties'
      }],
      value: activeTab,
      onChange: function onChange(options) {
        return setActiveTab(options.value);
      },
      children: React.createElement(React.Fragment, null, activeTab === 'visualizations' && React.createElement(Visualizations, {
        data: dashboardState.data,
        widgets: widgets,
        onSelectWidgetId: setSelectedWidgetId,
        selectedWidgetId: selectedWidgetId,
        onEdit: function onEdit() {
          return setActiveTab('properties');
        }
      }), activeTab === 'properties' && React.createElement(Properties, {
        selectedWidgetId: selectedWidgetId
      }))
    }
  }, React.createElement("div", null, dashboardState.error ? React.createElement(Typography, {
    color: "error",
    align: "center"
  }, dashboardState.error) : React.createElement(React.Fragment, null, React.createElement(BlockPrompt, {
    when: dashboardState.editorState.serverContent !== dashboardState.content
  }), widgets.find(function (widget) {
    return widget.id === selectedWidgetId;
  }) && React.createElement(WidgetPreview, {
    workspace: props.workspace,
    path: props.path,
    widgetId: selectedWidgetId
  })))));
};
/**
 * @param {import('./types').DashboardEditorProps} props
 */


var DashboardEditorWrapper = function DashboardEditorWrapper(props) {
  return React.createElement(DesignImdbProvider, null, React.createElement(DashboardProvider, null, React.createElement(DashboardEditor, props)));
};

export default DashboardEditorWrapper;